import type { ReactElement } from 'react';
import { BreakpointMedia } from 'config';
import type IPicture from 'models/IPicture';

type Props = {
  versions: IPicture[];
  useHighResOnly?: boolean;
  alt?: string;
  isProgramPage?: boolean;
  isDiversePlanPage ?: boolean;
};

type Sources = {
  lg: string[];
  md: string[];
  sm: string[];
  xs: string[];
  xxs: string[];
};

function versionsToSources(versions: IPicture[]): Sources {
  const sources = {} as Sources;

  versions.forEach((version: IPicture) => {
    const srcSet = sources[version.breakpoint] || [];
    // @ts-expect-error TODO: fix null safety
    const pixelDensity = (version.pixel_density || 'x1').match(/\d+/)[0];

    srcSet.push(`${version.image_url} ${pixelDensity}x`);

    sources[version.breakpoint] = srcSet;
  });

  return sources;
}

function Picture({
  versions,
  useHighResOnly = false,
  isProgramPage = false,
  isDiversePlanPage = false,
  alt,
}: Props): ReactElement {
  const sources = versionsToSources(
    useHighResOnly
      ? versions.filter((version) => version.pixel_density === 'x2')
      : versions,
  );

  return (
    <div className="c-recipe__content--top">
      <picture>
        {Object.keys(sources).map((breakpoint) => (
          <source
            key={breakpoint}
            media={BreakpointMedia[breakpoint.toUpperCase()]}
            srcSet={sources[breakpoint].join(',')}
          />
        ))}
        <img
          className={`${isDiversePlanPage ? 'c-diversified-plans__recipe-image' : 'c-recipe__image'} ${isProgramPage ? 'c-recipe__content--program' : ''}  c-order__active-content`}
          srcSet={sources.lg.join(',')}
          alt={alt}
        />
      </picture>
    </div>

  );
}

export default Picture;
